import { Column, Bar } from '@ant-design/plots'
import React from 'react'

const BarGraph = ({
  data,
  xField,
  yField,
  isColumn = true,
  xShowColumn = true,
  yShowColumn = true,
  tooltipFunc = (data) => data,
  integerAxisLabels = false,
  onBarClick = null,
}) => {
  // Axis label formatter for integers
  const intAxisLabelFormatter = (val) => {
    if (typeof val !== 'number') {
      return val
    }
    return Number.isInteger(val) ? val : ''
  }

  const config = {
    data: data,
    xField: xField,
    yField: yField,
    markBackground: {
      style: {
        fill: '#eee',
      },
    },
    style: {
      maxWidth: 50,
    },
    legend: false,
    axis: {
      x: xShowColumn,
      y: yShowColumn,
    },
    tooltip: {
      items: [
        (datum, index, data, column) => {
          if (!yField || typeof datum[yField] === 'undefined') {
            return { value: '' }
          }
          // Show < 1m for 0.1 (was 0) values
          if (datum[yField] === 0.1) {
            return { value: '< 1m' }
          }
          return { value: tooltipFunc(datum[yField]) }
        },
      ],
    },
    // Remove onEvent, use onReady for reliable element:click
  }
  if (integerAxisLabels) {
    if (yShowColumn) {
      // don't override hidden y-axis
      config.axis = {
        ...config.axis,
        y: {
          labelFormatter: intAxisLabelFormatter,
        },
      }
    }
  }
  config.onReady = (plot) => {
    plot.chart.off('element:click')
    plot.chart.on('element:click', (evt) => {
      const datum = evt.data?.data
      if (datum && datum[xField] && onBarClick) {
        onBarClick(datum[xField])
      }
    })
  }
  return (
    <>
      {!isColumn && <Bar {...config} />}
      {isColumn && <Column {...config} />}
    </>
  )
}

export default BarGraph
